import api from '@/api/api'
import router from '@/router/index'
import Vue from 'vue'
import i18n, {idiomasApp} from '@/plugins/vue-i18n'
import md5 from 'blueimp-md5'

export default {
  namespaced: true,
  state: {
    usuario: {
      id: null,
      email: '',
      nombre: '',
      token: '',
      passwordUsoUnico: false,
      entornos: [],
      roles: null,
      entornoId: 0,
      idubapi: null,
      estilo: {
        idiomas: window.idiomas || idiomasApp,
        idioma_defecto: window.idioma_defecto || idiomasApp[0]
      },
      codSubdominioAgrupacion: null,
      idioma: window.idioma_defecto || idiomasApp[0],
      passTemporal: null
    },
    loaded: false,
    sessionChecked: false,
    checkingSession: false,
    comprobandoNumReservas: false
  },
  mutations: {
    setUsuario (state, usuario) {
      state.usuario = Object.assign(state.usuario, usuario)
      i18n.locale = state.usuario.idioma
      i18n.fallbackLocale = state.usuario.estilo.idioma_defecto
    },
    setPasswordUsoUnico (state, payload) {
      state.usuario.passwordUsoUnico = payload
    },
    setEstilo (state, payload) {
      state.usuario.estilo = payload
    },
    setEntornosTrabajo (state, payload) {
      state.usuario.entornos = payload.entornos
      state.usuario.entornoId = payload.entornoId
      state.usuario.idubapi = payload.idubapi
    },
    setIdioma (state, payload) {
      state.usuario.idioma = payload
      i18n.locale = state.usuario.idioma
    },
    logOut (state) {
      state.usuario.id = null
    },
    loaded (state, payload) {
      state.loaded = payload
    },
    sessionChecked (state, payload) {
      state.sessionChecked = payload
    },
    setCodSubdominioAgrupacion (state, payload) {
      state.usuario.codSubdominioAgrupacion = payload
    },
    setIdiomas (state, {idiomas, idiomaDefecto}) {
      let idiomasFiltrados = idiomas.filter(x => idiomasApp.some(y => x == y))
      if (idiomasFiltrados.length === 0) {
        idiomasFiltrados = idiomasApp
      }
      state.usuario.estilo.idiomas = idiomasFiltrados
      state.usuario.estilo.idioma_defecto = idiomasFiltrados.some(x => x === idiomaDefecto) ? idiomaDefecto : idiomasFiltrados[0]
    },
    checkingSession (state, payload) {
      state.checkingSession = payload
    },
    comprobandoNumReservas (state, payload) {
      state.comprobandoNumReservas = payload
    },
    setPassTemporal (state, payload) {
      state.passTemporal = payload
    }
  },
  actions: {
    restaurarSesion ({commit}) {
      return new Promise((resolve) => {
        const usuarioJson = localStorage.getItem('usuario')
        let usuario = null
        if (usuarioJson !== null) {
          usuario = JSON.parse(usuarioJson)
        }
        if (window.codSubdominioAgrupacion) {
          if (usuario !== null) {
            if (usuario.codSubdominioAgrupacion !== window.codSubdominioAgrupacion) {
              localStorage.removeItem('usuario', null)
              commit('setCodSubdominioAgrupacion', window.codSubdominioAgrupacion)
              commit('setIdiomas',{idiomas: window.idiomas, idiomaDefecto: window.idioma_defecto})
            } else {
              usuario.codSubdominioAgrupacion = window.codSubdominioAgrupacion || usuario.codSubdominioAgrupacion
              commit('setUsuario', usuario)
            }
          } else {
            commit('setCodSubdominioAgrupacion', window.codSubdominioAgrupacion)
            if (window.idiomas && window.idioma_defecto) {
              commit('setIdiomas',{idiomas: window.idiomas, idiomaDefecto: window.idioma_defecto})
              commit('setIdioma', window.idioma_defecto)
            }
          }
        } else if (usuario !== null && usuario.codSubdominioAgrupacion) {
          commit('setUsuario', usuario)
          window.logo = 'data:image;base64,' + usuario.estilo.logo
          Vue.prototype.$vuetify.theme = Object.assign({}, Vue.prototype.$vuetify.theme, usuario.estilo.theme)
        }
        resolve()
      })
    },
    logIn ({commit, getters, dispatch}, {usermail, password}) {
      return new Promise((resolve, reject) => {
        commit('setPassTemporal', password)
        api.post('/login/login_fr', {
          jsondata: JSON.stringify({
            parametros: {
              usermail: usermail,
              password: md5(password),
              cod_subdominio_agrupacion: getters.codSubdominioAgrupacion
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              const usuario = {
                id: response.data.result.data.data.ID_ACTOR,
                nombre: response.data.result.data.data.NOMBRE_ACTOR,
                token: response.data.result.data.data.token_sesion,
                passwordUsoUnico: response.data.result.data.data.PASSWORD_USUARIO_USO_UNICO,
                roles: response.data.result.data.data.COD_ROLES,
                entornos: response.data.result.data.data.ENTORNOS_TRABAJO,
                entornoId: response.data.result.data.data.ID_ENTORNO_SELECCIONADO,
                idubapi: response.data.result.data.data.IDUBAPI_SELECCIONADO,
                codSubdominioAgrupacion: getters.codSubdominioAgrupacion,
                estilo: response.data.result.data.data.estilo,
                idioma: response.data.result.data.data.idioma
              }
              dispatch('textos/unload', null, { root: true })
              localStorage.setItem('usuario', JSON.stringify(usuario))
              commit('setUsuario', usuario)
              commit('sessionChecked', true)
              resolve(usuario)
            } else {
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    autoLoginCRM ({commit, getters, dispatch}, obj) {
      return new Promise((resolve, reject) => {
        api.post('/login/login_crm', {
          jsondata: JSON.stringify({
            parametros: obj
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              const usuario = {
                id: response.data.result.data.data.ID_ACTOR,
                nombre: response.data.result.data.data.NOMBRE_ACTOR,
                token: response.data.result.data.data.token_sesion,
                passwordUsoUnico: response.data.result.data.data.PASSWORD_USUARIO_USO_UNICO,
                roles: response.data.result.data.data.COD_ROLES,
                entornos: response.data.result.data.data.ENTORNOS_TRABAJO,
                entornoId: response.data.result.data.data.ID_ENTORNO_SELECCIONADO,
                idubapi: response.data.result.data.data.IDUBAPI_SELECCIONADO,
                codSubdominioAgrupacion: getters.codSubdominioAgrupacion,
                estilo: response.data.result.data.data.estilo,
                idioma: response.data.result.data.data.idioma
              }
              dispatch('textos/unload', null, { root: true })
              localStorage.setItem('usuario', JSON.stringify(usuario))
              commit('setUsuario', usuario)
              commit('sessionChecked', true)
              resolve(usuario)
            } else {
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    loginCRMSimplificada ({commit, getters, dispatch}, obj) {
      return new Promise((resolve, reject) => {
        api.post('/login/login_crm_simplificada', {
          jsondata: JSON.stringify({
            parametros: obj
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              const usuario = {
                id: response.data.result.data.data.ID_ACTOR,
                nombre: response.data.result.data.data.NOMBRE_ACTOR,
                token: response.data.result.data.data.token_sesion,
                passwordUsoUnico: response.data.result.data.data.PASSWORD_USUARIO_USO_UNICO,
                roles: response.data.result.data.data.COD_ROLES,
                entornos: response.data.result.data.data.ENTORNOS_TRABAJO,
                entornoId: response.data.result.data.data.ID_ENTORNO_SELECCIONADO,
                idubapi: response.data.result.data.data.IDUBAPI_SELECCIONADO,
                codSubdominioAgrupacion: getters.codSubdominioAgrupacion,
                estilo: response.data.result.data.data.estilo,
                idioma: response.data.result.data.data.idioma
              }
              dispatch('textos/unload', null, { root: true })
              localStorage.setItem('usuario', JSON.stringify(usuario))
              commit('setUsuario', usuario)
              commit('sessionChecked', true)
              resolve(usuario)
            } else {
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    logInIncrustado ({commit, getters, dispatch}, {usermail, password}) {
      return new Promise((resolve, reject) => {
        api.post('/login/login_desde_incrustado', {
          jsondata: JSON.stringify({
            parametros: {
              usermail: usermail,
              password: md5(password),
              cod_subdominio_agrupacion: getters.codSubdominioAgrupacion
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              const usuario = {
                id: response.data.result.data.data.ID_ACTOR,
                nombre: response.data.result.data.data.NOMBRE_ACTOR,
                token: response.data.result.data.data.token_sesion,
                passwordUsoUnico: response.data.result.data.data.PASSWORD_USUARIO_USO_UNICO,
                roles: response.data.result.data.data.COD_ROLES,
                entornos: response.data.result.data.data.ENTORNOS_TRABAJO,
                entornoId: response.data.result.data.data.ID_ENTORNO_SELECCIONADO,
                idubapi: response.data.result.data.data.IDUBAPI_SELECCIONADO,
                codSubdominioAgrupacion: getters.codSubdominioAgrupacion,
                estilo: response.data.result.data.data.estilo,
                idioma: response.data.result.data.data.idioma
              }
              dispatch('textos/unload', null, { root: true })
              localStorage.setItem('usuario', JSON.stringify(usuario))
              commit('setUsuario', usuario)
              commit('sessionChecked', true)
              resolve(usuario)
            } else {
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    cambiarEntornoTrabajo ({commit, getters, dispatch}, {id, idubapi}) {
      return new Promise((resolve, reject) => {
        api.post('/login/cambiar_entorno_trabajo', {
          jsondata: JSON.stringify({
            parametros: {
              id: id,
              idubapi: idubapi
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              const usuario = Object.assign({}, getters.usuario, {
                entornoId: response.data.result.data.data.ID_ENTORNO_SELECCIONADO,
                idubapi: response.data.result.data.data.IDUBAPI_SELECCIONADO,
              })
              dispatch('textos/unload', null, { root: true })
              localStorage.setItem('usuario', JSON.stringify(usuario))
              commit('setUsuario', usuario)
              commit('sessionChecked', true)
              resolve(usuario)
            } else {
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    confirmarCorreo (store, obj) {
      return new Promise((resolve, reject) => {
        api.post('/login/confirmar_correo', {
          jsondata: JSON.stringify({
            parametros: {
              actorId: obj.actorId,
              token: obj.token
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve(response.data.result.data.data.ruta_portal)
            } else {
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    reenviarMail (store, actorId) {
      return new Promise((resolve, reject) => {
        api.post('/login/reenviar_correo_confirmacion', {
          jsondata: JSON.stringify({
            parametros: {
              actorId: actorId
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    registro ({commit, getters}, obj) {
      return new Promise((resolve, reject) => {
        api.post('/login/registrar_fr', {
          jsondata: JSON.stringify({
            parametros: {
              ...obj,
              password: md5(obj.password)
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              const usuario = {
                id: response.data.result.data.data.ID_ACTOR,
                nombre: response.data.result.data.data.NOMBRE_ACTOR,
                token: response.data.result.data.data.token_sesion,
                passwordUsoUnico: response.data.result.data.data.PASSWORD_USUARIO_USO_UNICO,
                roles: response.data.result.data.data.COD_ROLES,
                entornos: response.data.result.data.data.ENTORNOS_TRABAJO,
                entornoId: response.data.result.data.data.ID_ENTORNO_SELECCIONADO,
                idubapi: response.data.result.data.data.IDUBAPI_SELECCIONADO,
                codSubdominioAgrupacion: getters.codSubdominioAgrupacion,
                estilo: response.data.result.data.data.estilo,
                idioma: response.data.result.data.data.idioma
              }
              localStorage.setItem('usuario', JSON.stringify(usuario))
              commit('setUsuario', usuario)
              commit('sessionChecked', true)
              resolve(usuario)
            } else {
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    cambiarIdioma ({commit, getters}, idioma) {
      return new Promise((resolve, reject) => {
        api.post('/login/cambiar_idioma', {
          jsondata: JSON.stringify({
            parametros: {
              idioma
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              let usuario = getters.usuario
              if (usuario.id != null && usuario.id !== response.data.result.data.data.actorId) {
                commit('logOut') // Si el usuario ha cambiado entonces quitarle el id ya que expiró la sesión
              }
              commit('setIdioma', response.data.result.data.data.idioma)
              localStorage.setItem('usuario', JSON.stringify(getters.usuario))
              resolve()
            } else {
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    async logOut ({commit, dispatch}) {
      try {
        await api.post('/login/logoff_fr')
      } catch (e) {
        console.log(e)
      } finally {
        localStorage.removeItem('usuario', null)
        commit('logOut')
        dispatch('textos/unload', null, { root: true })
        dispatch('alerts/add', { texto: i18n.t('store.cerroSesion'), color: 'success' }, { root: true })
        router.push({ name: 'login' })
      }
    },
    resetPassword (store, usermail) {
      return new Promise((resolve, reject) => {
        api.post('/login/resetear_password_usuario_fr', {
          jsondata: JSON.stringify({
            parametros: {
              usermail: usermail
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    modificarPasswordUsoUnico ({commit, getters}, {password, passwordRepetida}) {
      return new Promise((resolve, reject) => {
        api.post('/login/modificar_password_usuario_uso_unico_fr', {
          jsondata: JSON.stringify({
            parametros: {
              password: password,
              password_repetida: passwordRepetida,
              password_actual: getters.getPassTemporal
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              commit('setPasswordUsoUnico', false)
              localStorage.setItem('usuario', JSON.stringify(getters.usuario))
              resolve(response.data)
            } else {
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    modificarPassword ({getters}, {password, passwordRepetida, passwordActual}) {
      return new Promise((resolve, reject) => {
        api.post('/login/modificar_password_usuario_fr', {
          jsondata: JSON.stringify({
            parametros: {
              password: password,
              password_repetida: passwordRepetida,
              password_actual: passwordActual
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              localStorage.setItem('usuario', JSON.stringify(getters.usuario))
              resolve(response.data)
            } else {
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    comprobarSesion ({commit}) {
      return new Promise((resolve, reject) => {
        api.get('/login/comprobar_sesion_activa')
          .then(response => {
            if (!response.data.result.ok) {
              commit('logOut')
              localStorage.removeItem('usuario')
            } else {
              commit('sessionChecked', true)
            }
            resolve()
          })
          .catch(e => {
            commit('logOut')
            localStorage.removeItem('usuario')
            reject(e)
          })
      })
    },
    setVariablesSesion (store, obj) {
      return new Promise((resolve, reject) => {
        api.post('/login/set_variables_sesion', {
          jsondata: JSON.stringify({
            parametros: {
              cod_subdominio_agrupacion: obj.codigoAgrupacion,
              idubapi: obj.idubapi
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    setEntornoTrabajoIncrustado () {
      return new Promise((resolve, reject) => {
        api.post('/estilo/set_entorno_trabajo_incrustado', {
          jsondata: JSON.stringify({
            parametros: {
              cod_subdominio_agrupacion: window.codSubdominioAgrupacion,
              idubapi: window.idubapi
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    setLoaded ({commit}, payload) {
      commit('loaded', payload)
    },
    setSessionChecked ({commit}, payload) {
      commit('sessionChecked', payload)
    },
    setCheckingSession ({commit}, payload) {
      commit('checkingSession', payload)
    },
    setComprobandoNumReservas ({commit}, payload) {
      commit('comprobandoNumReservas', payload)
    },
    comprobarNumeroReservas ({ dispatch }) {
      return new Promise((resolve, reject) => {
        api.get('/login/reserva_unica_usuario')
          .then(response => {
            if (response.data.result.ok) {
              resolve(response.data.result.data.data)
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    }
  },
  getters: {
    usuario (state) {
      return state.usuario
    },
    passwordUsoUnico (state) {
      return state.usuario.passwordUsoUnico
    },
    loaded (state) {
      return state.loaded
    },
    sessionChecked (state) {
      return state.sessionChecked
    },
    checkingSession (state) {
      return state.checkingSession
    },
    comprobandoNumReservas (state) {
      return state.comprobandoNumReservas
    },
    loggedIn (state) {
      return state.usuario.id != null && state.usuario.id.length > 0
    },
    esAdministrador (state) {
      return state.usuario.roles && state.usuario.roles.length > 0 ? state.usuario.roles.includes('VD_ADMINISTRADOR') : false
    },
    esComercial (state, getters) {
      return state.usuario.roles && state.usuario.roles.length > 0 && !getters.esAdministrador ? state.usuario.roles.includes('VD_COMERCIAL') : false
    },
    esPbc (state, getters) {
      return state.usuario.roles && state.usuario.roles.length > 0 && !getters.esAdministrador ? state.usuario.roles.includes('VD_PBC') : false
    },
    esCliente (state, getters) {
      return state.usuario.roles && state.usuario.roles.length > 0 && !getters.esAdministrador && !getters.esComercial && !getters.esPbc ? state.usuario.roles.includes('VD_CLIENTE') : false
    },
    idubapi (state) {
      let entornoActual = state.usuario.entornos.find(e => e.id === state.usuario.entornoId)
      if (!entornoActual) {
        return null
      }
      return entornoActual.idubapis.find((idubapiEntorno) => {
        return idubapiEntorno.ID_BD_PRINEX === state.usuario.idubapi
      })
    },
    codSubdominioAgrupacion (state) {
      return state.usuario.codSubdominioAgrupacion
    },
    getIdioma (state) {
      return state.usuario.idioma
    },
    getIdiomaDefecto (state) {
      return state.usuario.estilo.idioma_defecto
    },
    getIdiomas (state) {
      return state.usuario.estilo.idiomas
    },
    getPassTemporal (state) {
      return state.passTemporal
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/login/store.js